import { render, staticRenderFns } from "./AboutModal.vue?vue&type=template&id=014845ee"
import script from "./AboutModal.vue?vue&type=script&lang=ts"
export * from "./AboutModal.vue?vue&type=script&lang=ts"
import style0 from "./AboutModal.vue?vue&type=style&index=0&id=014845ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports